<h1 class="ds-title-3 ds-color-core-neutral-10">{{'ODD.overlay.title' | translate: { first_name: name } }}</h1>
<p class="ds-running-1 ds-color-core-neutral-10" [innerHTML]="'ODD.overlay.description' | translate : { days, date }"></p>
<app-ds-callout
  variant="warning"
  [title]="'ODD.overlay.callout.title' | translate"
  [description]="'ODD.overlay.callout.description.newIntro' | translate"
></app-ds-callout>

<app-ds-button (clicked)="onReview()">{{'ODD.overlay.buttons.review' | translate}}</app-ds-button>
<app-ds-button (clicked)="onDoItLater()" variant="outline">{{'ODD.overlay.buttons.postpone' | translate}}</app-ds-button>
